// Libraries
import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

// Common components
import { TableLayout } from 'Components'

// Specs
import { TableSpecs } from 'Views/PreventiveMeasures/Specs'

// Styles
import './Styles/List.less'

class PreventiveMeasuresList extends Component {
  static propTypes = {
    // Témoin d'approvisionnement des données
    loading: PropTypes.bool,

    // Données de la vue
    dataList: PropTypes.array,

    // Données de construction du tableau
    TableSpecs: PropTypes.object,

    // Fonctions hérités du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func)
  }

  static defaultProps = {
    // Témoin d'approvisionnement des données
    loading: true,

    // Données de la vue
    dataList: []
  }

  constructor(props) {
    super(props)

    this.state = {
      pagination: TableSpecs.pagination
    }
  }

  handleOnChange = pagination => {
    this.setState({ pagination })
  }

  render() {
    const { loading, dataList, constructorFunctions } = this.props
    const { pagination } = this.state

    // Ajout des données au tableau
    TableSpecs.rows = dataList

    // Ajout des actions au clic sur un ligne du tableau
    TableSpecs.onRow = (preventiveMeasure, id) => ({
      onClick: () =>
        get(constructorFunctions, 'handleRowClick', () => {})(
          preventiveMeasure,
          id
        )
    })

    // Pagination courante
    TableSpecs.pagination = pagination
    TableSpecs.onChange = this.handleOnChange

    TableSpecs.onDraggedRowReleased = draggedData =>
      get(constructorFunctions, 'handleDraggedRowReleased', () => {})(
        draggedData
      )

    // Ajout des actions multiples sur le tableau
    TableSpecs.actions.selection.delete.onClick = get(
      constructorFunctions,
      'askDeleteManyPreventiveMeasures'
    )

    // Ajout des actions des boutons
    TableSpecs.actions.global.create.onClick = get(
      constructorFunctions,
      'askCreatePreventiveMeasure'
    )

    return (
      <main className='screen preventiveMeasures preventiveMeasures-list'>
        <TableLayout loading={loading} {...TableSpecs} />
      </main>
    )
  }
}

export default PreventiveMeasuresList
